import { render, staticRenderFns } from "./FinancialFacilities.vue?vue&type=template&id=2162c1cd"
import script from "./FinancialFacilities.vue?vue&type=script&lang=js"
export * from "./FinancialFacilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2162c1cd')) {
      api.createRecord('2162c1cd', component.options)
    } else {
      api.reload('2162c1cd', component.options)
    }
    module.hot.accept("./FinancialFacilities.vue?vue&type=template&id=2162c1cd", function () {
      api.rerender('2162c1cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/FinancialFacilities.vue"
export default component.exports